import { getTranslationWithParams } from "common";
import { useTranslations } from "hooks";
import { useCallback } from "react";

/**
 * Testo della superficie SLA dal catalogo (`getTranslationWithParams`): i
 * segnaposto `{param}` vengono interpolati; senza traduzione resta la chiave,
 * come nel resto dell'applicazione.
 */
const useSlaEditorText = () => {
  const translations = useTranslations();

  return useCallback(
    (key: string, params: Record<string, string | number> = {}): string =>
      getTranslationWithParams(translations, key, params),
    [translations],
  );
};

export default useSlaEditorText;
